<div class="flex flex-row align-middle items-center">
  {{ 'header.line-of-business.label' | translate }}
  <nx-formfield appearance="outline" class="pb-3 mr-5 ml-3">
    <nx-dropdown
      type="text"
      [formControl]="lineOfBusinessControl"
      [placeholder]="'header.line-of-business.placeholder' | translate"
      class="min-w-36"
      data-testid="line-of-business-selector"
    >
      @for (lineOfBusiness of linesOfBusiness; track $index) {
        <nx-dropdown-item [value]="lineOfBusiness.code">{{ lineOfBusiness.i18n | translate }}</nx-dropdown-item>
      }
    </nx-dropdown>
  </nx-formfield>
</div>
